import app from 'flarum/forum/app';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import UserPage from 'flarum/forum/components/UserPage';
import IndexPage from 'flarum/forum/components/IndexPage';
import SiteSplash from './splash';
import { extend, override } from 'flarum/common/extend';


app.initializers.add('arumoon/flarum-age-check', () => {
    extend(DiscussionPage.prototype, 'pageContent', (items) => { 
      items.add('agebox', <SiteSplash />);
      $(".DiscussionPage-stream").addClass('thegoods')
      return items;
    });

    extend(IndexPage.prototype, 'sidebarItems', (items) => { 
      items.add('agebox', <SiteSplash />);
      $(".DiscussionList").addClass('thegoods')

      return items;
    });

  
}, 500);
